<template>
  <div class="agreement-page">
    <content-page type="agreement" title="用户协议" />
  </div>
</template>

<script>
import ContentPage from '../components/ContentPage.vue';

export default {
  name: 'AgreementPage',
  components: {
    ContentPage
  }
}
</script>

<style scoped>
.agreement-page {
  min-height: 100vh;
}
</style> 